
import { useState, useEffect, useContext } from "react";
import { useStyle } from '../../context/styleContext/styleContext';
import { useNavigate, Link } from 'react-router-dom';
import { ShoppingCartContext } from '../../context/shoppingCartContext/shoppingCartContext';
import {
  Box,
  Typography,
  Button,
  Divider,
  useMediaQuery,
  Card,
  CardContent,
  CardMedia,
  IconButton
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';

export default function ShoppingCart() {
  const { style } = useStyle();
  const navigate = useNavigate();
  const { cartItems, cartSubtotal, removeFromCart } = useContext(ShoppingCartContext);
  const [taxTotal, setTaxTotal] = useState(0);
  const isMobile = useMediaQuery("(max-width:768px)");

  useEffect(() => {
    document.title = 'Parish Audio | Shopping Cart';
  }, []);

  const navToCheckout = () => {
    navigate('/checkout');
  };

  const deleteFromCart = (sku) => {
    removeFromCart(sku);
  };

  const renderEmptyCart = () => (
    <Box sx={{ textAlign: 'center', mt: 8 }}>
      <Typography variant="h1" sx={{fontSize:'1.4rem', color: style.color4, fontStyle:'bold' }}><strong>Your cart is empty</strong></Typography>
      <Box component="img" src="/shopping_cart.svg" sx={{ mt: 2, maxWidth: 250, height: 'auto' }} />
      <Box mt={4}>
        <Link to="/plugins" style={{ color: style.color4 }}>Return to Shop</Link>
      </Box>
      <Box mt={1}>
        <Link to="/home" style={{ color: style.color4 }}>Home</Link>
      </Box>
    </Box>
  );

  const renderCartItem = (item) => (
    <Card key={item.SKU} sx={{ display: 'flex', mb: 2, backgroundColor: style.color1, color: style.color4, borderRadius: 2, boxShadow: 6 }}>
      <a href={"/products/" + item.productURI}>
      <CardMedia
        component="img"
        sx={{ width: '75%', objectFit: 'contain', p: 1, borderRadius: 2, borderTopRightRadius:0, borderBottomRightRadius:0, margin:'auto' }}
        image={item.images[0].URI}
        alt={item.images[0].altText}
      />
      </a>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth:'50%', backgroundColor:style.color2}}>
        <CardContent>
        <a href={"/products/" + item.productURI}>
          <Typography sx={{ fontSize:'1.3rem', color: style.color4, fontStyle:'bold', textAlign:'left' }}>{item.name}</Typography>
        </a>  
          <Typography variant="body2" sx={{ mt: 1, fontSize:'1.1rem' }}>${item.price.toFixed(2)}</Typography>
        </CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', pr: 1, pb: 0, mt:6}}>
          <IconButton onClick={() => deleteFromCart(item.SKU)} sx={{ color: style.color4 }}>
            <DeleteIcon />
          </IconButton>
        </Box>
      </Box>
    </Card>
  );

  const renderCartSummary = () => (
    <Box sx={{ mt: 0, p: 3, backgroundColor: style.color1, borderRadius: 2, boxShadow: 8 }}>
      <Typography variant="h1" sx={{ mb: 2, fontSize:'1.3rem', fontWeight:'bold' }}>Order Summary</Typography>
      <Divider sx={{ borderColor: style.color2, mb: 2 }} />
      <Typography sx={{ mb: 1 }}>Subtotal: <strong>${cartSubtotal.toFixed(2)}</strong></Typography>
      <Typography sx={{ mb: 1 }}>Sales Tax: <strong>${taxTotal.toFixed(2)}</strong></Typography>
      <Typography variant="h2" sx={{fontSize:'1.2rem'}}>Total: <strong>${(cartSubtotal + taxTotal).toFixed(2)}</strong></Typography>
      <Button
        fullWidth
        variant="contained"
        onClick={navToCheckout}
        sx={{ mt: 3, backgroundColor: style.color1, filter:'brightness(1.1)', borderColor:style.color2, borderWidth:'1px', borderStyle:'solid', boxShadow:10, color: style.color4, '&:hover': { filter:'brightness(1.2)' } }}
      >
        Proceed to Checkout
      </Button>
    </Box>
  );

  return (
    <Box sx={{ width: '95%', maxWidth: 1000, margin: 'auto', minHeight: 'calc(100vh - 160px)', py: 4 }}>
      <Typography variant="h1" sx={{ fontSize:'1.5rem', mb: 4, color: style.color4, fontWeight:'bold' }}>Shopping Cart</Typography>
      {cartItems.length < 1 ? renderEmptyCart() : (
        <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 4 }}>
          <Box sx={{ flex: 2 }}>{cartItems.map(renderCartItem)}</Box>
          <Box sx={{ flex: 1 }}>{renderCartSummary()}</Box>
        </Box>
      )}
      {cartItems.length > 0 && (
        <Box sx={{ mt: 6, textAlign: 'center', color: style.color4 }}>
          <Typography>
            <strong>
              After checkout, your downloads will be available on the <Link to='/my-gear' style={{ color: style.color2 }}>My Gear</Link> page.
            </strong>
          </Typography>
        </Box>
      )}
    </Box>
  );
}

// import { useState, useEffect, useContext } from "react";
// import { useStyle } from '../../context/styleContext/styleContext';
// import {useNavigate, Link} from 'react-router-dom';
// import Button from '@mui/material/Button';
// import axios from 'axios';
// import { toast } from 'react-hot-toast';
// import ReactGA from 'react-ga4';
// //import ProductsTable from "../../components/ProductsTable/ProductsTable";
// //import ShoppingCartItemRow from "../../components/ShoppingCartItemRow/ShoppingCartItemRow";
// import ShoppingCartTable from "../../components/ShoppingCartTable/ShoppingCartTable";
// import { ShoppingCartContext } from '../../context/shoppingCartContext/shoppingCartContext';
// //import CartIcon from '/shoppping-cart.svg'
// import Card from '@mui/material/Card';
// import CardActions from '@mui/material/CardActions';
// import CardContent from '@mui/material/CardContent';
// import CardMedia from '@mui/material/CardMedia';
// import Typography from '@mui/material/Typography';

// export default function ShoppingCart() {
//     const { style, setStyle } = useStyle();
//     const [products, setProducts] = useState([]); // Corrected initialization as an empty array
//     const [productDetails, setProductDetails] = useState([]);
//     const navigate = useNavigate()
//     const { cartItems, cartSubtotal, removeFromCart } = useContext(ShoppingCartContext);
//     const [taxTotal, setTaxTotal] = useState(0);

//     const [width, setWidth] = useState(window.innerWidth)
//     const [height, setHeight] = useState(window.innerHeight)

//     function handleWindowSizeChange() {
//         setWidth(window.innerWidth);
//         setHeight(window.innerHeight);
//     }
//     useEffect(() => {
//         window.addEventListener('resize', handleWindowSizeChange);
//         return () => {
//             window.removeEventListener('resize', handleWindowSizeChange);
//         }
//     }, []);

//     const deleteFromCart = async (productSKU) => {


//       console.log("Sending request to cart componant to DELETE..", productSKU)
  
//       removeFromCart(productSKU)  
//   }
    
//     const isMobile = width <= 768;
//     //const isMobile = true;

//     // Google Analytics pageview tracking
//     ReactGA.send({
//         hitType: "pageview",
//         page: "shopping_cart",
//         title: "shopping_cart",
//     });

//     // Set the document title when the page loads
//     useEffect(() => {
//         document.title = 'Parish Audio | Cutting-Edge Audio Processing | Shopping Cart';
//     }, []);

//     const navToCheckout = () => {

//       navigate('/checkout')
//     }


//     return (
//         <>
//         <div style={{height:'100%', minHeight:height - 130, margin:'auto'}}>


        
        
//             {cartItems.length < 1 &&(<>
//                     <div style={{textAlign:'center', margin:'auto', color:style.color4}}><h1 style={{paddingTop:'40px'}}>Your cart Is empty</h1></div>
//                     <div style={{textAlign:'center', margin:'auto'}}>

//                     <img src='/shopping_cart.svg' alt='Light Blue shopping cart' style={{flex:1,height:'250px', maxWidth:'100%', maxHeight:'100%', margin:'auto', textAlign:'center', marginTop:'30px', marginBottom:'15px', paddingRight:'15px'}} />
//                     </div>
//                     <div style={{textAlign:'center', marginTop:'30px'}}><a href={"/plugins"} style={{color:style.color4}}>Return to Shop</a></div>
//                     <div style={{textAlign:'center', marginTop:'15px'}}><a href={"/home"} style={{color:style.color4}}>Home</a></div>
//                     </>
//                   )}


//                 {/* -----------------   mobile --------------- */}


//                 {cartItems.length >= 1 && isMobile &&(<>
//                   <div style={{ display:'flex', flexDirection:'column', width:'95%', margin:'auto'}}>
//                 <div style={{display:'flex', flexDirection:'row', width:'95%', maxWidth:'1100px', margin:'auto', marginTop:'30px'}}>
//                 <h1 style={{fontSize:"18pt"}}>Shopping Cart:</h1>
//               </div>


//               <div style={{}}>              
//               {cartItems.map((item) => (


//                   <div key={item.SKU} style={{ margin:'auto', marginBottom:'15px',display:'flex', minHeight:'200px', backgroundColor:'rgb(25,31,34)', flexDirection:'row', width:'100%', borderColor:style.color3, borderWidth:'1px', borderStyle:'solid', borderRadius:'5px'}}>

//                                 <div style={{ textAlign:'center', padding:'15px', backgroundColor:'rgb(25,31,34)', margin:'auto', height:'100%'}}>
//                                               <a href={"/product/" + item.productURI}>
//                                               <img src={item.imageURIs[0]} style={{width:'75px', margin:'auto'}} />
//                                               </a>
//                                 </div>
//                                 <Card sx={{ backgroundColor:style.color2, color:style.color7, flex:1}}>

//                                           <CardContent>
//                                             <Typography gutterBottom variant="h5" component="div">
//                                             <a href={"/product/" + item.productURI} style={{color:'white'}}>
//                                               {item.name}
//                                               </a>
//                                             </Typography>
//                                             <Typography variant="body2" sx={{ color: 'text.secondary', color:style.color7}}>
//                                             <h3><strong>${item.price} </strong> </h3>
//                                             </Typography>
//                                           </CardContent>
//                                           <CardActions>
//                                              <Button onClick={() => deleteFromCart(item.SKU)} size="small">Remove From Cart</Button>
                                            
//                                           </CardActions>
//                                         </Card>

//                                 </div>

                                
                  
                  
                  
                  

//   ))}
              

//               </div>


                            
                       
//                         <div style={{flex:1}}>
//                             <table style={{margin:'auto', width:'100%', borderColor:style.color4, borderThickness:'1px', borderStyle:'solid', borderRadius:'5px', padding:'20px'}}>
//                               <tbody>
              
                              
//                             <tr>
//                               <td style={{width:'125px'}}><h3 style={{padding:'5px', margin:'0px'}}>Subtotal:</h3></td>
//                               <td><h3 style={{ padding:'5px', margin:'0px', textAlign:'center'}}>$ {parseFloat(cartSubtotal).toFixed(2)}</h3></td>
//                             </tr>
//                             <tr>
//                               <td><h3 style={{padding:'5px', margin:'0px'}}>Sales Tax</h3></td>
//                               <td><h3 style={{padding:'5px', margin:'0px', textAlign:'center'}}>$ {parseFloat(taxTotal).toFixed(2)}</h3></td>
              
//                             </tr>
//                             <tr>
//                               <td><h2 style={{padding:'5px', margin:'0px'}}><strong>TOTAL</strong></h2></td>
//                               <td><h2 style={{padding:'5px', margin:'0px', textAlign:'center'}}><strong>$ {parseFloat(cartSubtotal + taxTotal).toFixed(2)} </strong></h2></td>
              
//                             </tr>
//                             </tbody>
//                           </table>
              
//                           <Button onClick={navToCheckout} sx={{width:'100%', backgroundColor:style.color4, color:'white', marginTop:'25px','&:hover': {backgroundColor: style.color1 }}}> Proceed To Checkout </Button>   </div>
              

  
              
//               <div style={{width:'95%', maxWidth:'800px', margin:'auto', marginTop:'75px'}}>
//                 <p><strong>Once your order is complete, you can download your products from your <a href='/my-gear' style={{color:style.color4}}>gear</a> page</strong></p>
//               </div>
//               </div>
              
//               </>)}      

//                 {/* -----------------   desktop   --------------- */}

//               {cartItems.length >= 1 && !isMobile &&(<>
//                 <div style={{display:'flex', flexDirection:'row', width:'95%', maxWidth:'1100px', margin:'auto', marginTop:'30px'}}>
//                 <h1 style={{fontSize:"18pt"}}>shopping cart:</h1>
//               </div>

//                 <div style={{display:'flex', flexDirection:'row', width:'95%', maxWidth:'1100px', margin:'auto'}}>
                            
//                             <div style={{ textAlign: 'center', color: style.color4, width: '95%', maxWidth: '1000px', margin: 'auto'}}>
                                
//                                 <div style={{maxWidth:'1000px', margin:'auto'}}>
//                                   <ShoppingCartTable />
//                                 </div>  
//                             </div>
                       
//                         <div style={{flex:1, marginLeft:'10px'}}>
//                             <table style={{margin:'auto', width:'95%', borderColor:style.color4, borderThickness:'1px', borderStyle:'solid'}}>
//                               <tbody>
              
                              
//                             <tr>
//                               <td style={{width:'125px'}}><h3 style={{padding:'5px', margin:'0px'}}>Subtotal:</h3></td>
//                               <td><h3 style={{width:'125px', padding:'5px', margin:'0px', textAlign:'center'}}>$ {parseFloat(cartSubtotal).toFixed(2)}</h3></td>
//                             </tr>
//                             <tr>
//                               <td><h3 style={{padding:'5px', margin:'0px'}}>Sales Tax</h3></td>
//                               <td><h3 style={{padding:'5px', margin:'0px', textAlign:'center'}}>$ {parseFloat(taxTotal).toFixed(2)}</h3></td>
              
//                             </tr>
//                             <tr>
//                               <td><h2 style={{padding:'5px', margin:'0px'}}>TOTAL</h2></td>
//                               <td><h2 style={{padding:'5px', margin:'0px', textAlign:'center'}}>$ {parseFloat(cartSubtotal + taxTotal).toFixed(2)} </h2></td>
              
//                             </tr>
//                             </tbody>
//                           </table>
              
//                           <Button onClick={navToCheckout} sx={{width:'100%', backgroundColor:style.color1, color:'white', marginTop:'25px','&:hover': {backgroundColor: style.color4 }}}> Proceed To Checkout </Button>   </div>
              

//                       </div>    
              
//               <div style={{width:'95%', maxWidth:'800px', margin:'auto', marginTop:'75px'}}>
//                 <p><strong>Once your order is complete, you can download your products from the <a href='/my-gear' style={{color:style.color4}}>my gear</a> page</strong></p>
//               </div>
//               </>)}       
        

//         </div>

//         </>
//     );
// }








